import { cacheDom } from "../utils/QuerySelectors.js"
import { videoHtml, videoControl } from "../utils/helpers.js"

const dom = {}
const qs = {
  video: 'data-video',
  videoMobile: 'data-video-mobile',
  json: 'data-video-json',
  jsonMobile: 'data-video-mobile-json',
}
const qsAll = {
  sections: 'data-section-type="hero"',
}

const iObserver = new IntersectionObserver(items => {
  if (items[0].isIntersecting) {
    const section = items[0].target
    initVideo(section)
  }
})

const initVideo = (section) => {
  if(section.querySelector(`[${qs.json}]`)) {
    let video = section.querySelector(`[${qs.video}]`)
    let videoMobile = section.querySelector(`[${qs.videoMobile}]`)
    const json = JSON.parse(section.querySelector(`[${qs.json}]`).innerHTML)
    const jsonMobile = section.querySelector(`[${qs.jsonMobile}]`) ? JSON.parse(section.querySelector(`[${qs.jsonMobile}]`).innerHTML) : null

    if(!section.classList.contains('hero--video__inited')) {
      section.classList.add('hero--video__inited')
      if(!document.querySelector('#videojs-css')) {
        const link = document.createElement("link")
        link.rel = 'stylesheet'
        link.href = section.dataset.css
        link.id = 'videojs-css'
        document.body.append(link)

        const script = document.createElement("script")
        script.src = section.dataset.js
        script.id = 'videojs-js'
        document.body.append(script)
      }
      if(!video) {
        section.innerHTML = videoHtml(json.video.sources, json.sectionId, jsonMobile ? 'hero-media !hidden lg:!inline-block' : 'hero-media', json.controls, json.video.preview_image.src, json.caption_en) + section.innerHTML
        video = section.querySelector(`[${qs.video}]`)
        videoControl(video)
        
        if(section.querySelector('.hero-media--placeholder')) {
          setTimeout(() => {
            section.querySelector('.hero-media--placeholder').remove()
          }, 300)
        }
        if(jsonMobile) {
          section.innerHTML = videoHtml(jsonMobile.video.sources, jsonMobile.sectionId, 'hero-media !inline-block lg:!hidden', jsonMobile.controls, jsonMobile.video.preview_image.src, json.caption_en) + section.innerHTML
          videoMobile = section.querySelector(`[${qs.videoMobile}]`)
          videoControl(videoMobile)
        }
      }
      if(typeof videojs != 'undefined') videojs(video.id)
      if(typeof videojs != 'undefined' && videoMobile) videojs(videoMobile.id)
    }
  }
}

export const setupHero = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    iObserver.observe(section)
  })
}